import React, { FC, useCallback, useEffect } from 'react';
import { Button, Typography } from '@galaxy-ds/core';
import style from './style.module.less';
import PlusIcon from './header/plus.svg?react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import selectors from '../../redux/selectors';
import { actions } from '../../redux/slices';
import LoadingSvg from './loading.svg?react';
import TickCircleIcon from './tick-circle.svg?react';
import MatterIcon from './matter.svg?react';
import { steps } from '../../components/onboarding/steps';
import { useTranslation } from 'react-i18next';
interface Props {
  id: string;
  openMatterCreatedToast?: () => void;
}

export const CreateMatter: FC<Props> = (props) => {
  const { id, openMatterCreatedToast } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showIntakeTooltip, setShowIntakeTooltip] = React.useState(true);
  const tooltip = 'Private info must be received to create matter';

  const [isConvertingToMatterTriggered, setIsConvertingToMatterTriggered] =
    React.useState(false);

  const connection = useAppSelector(
    selectors.lawyerConnection.getConnectionById(id)
  );
  const isConvertingToMatter = useAppSelector(
    selectors.prematter.isConvertingToMatter()
  );
  const convertToMatter = useCallback(() => {
    if (!isConvertingToMatter) {
      dispatch(actions.prematter.convertToMatter({ id }));
      setIsConvertingToMatterTriggered(true);
    }
  }, [dispatch, id, isConvertingToMatter, setIsConvertingToMatterTriggered]);

  useEffect(() => {
    if(!connection.convertedToMatterAt && 
      !connection?.permissions?.userDetails) {
      setShowIntakeTooltip(true);
    }
    else {
      setShowIntakeTooltip(false);
    }
  }, [connection.convertedToMatterAt, connection?.permissions?.userDetails]);

  useEffect(() => {
    if (isConvertingToMatterTriggered && connection?.convertedToMatterAt) {
      openMatterCreatedToast?.();
      setIsConvertingToMatterTriggered(false);
    }
  }, [isConvertingToMatterTriggered, 
    connection?.convertedToMatterAt, 
    openMatterCreatedToast]);

  return (
    <div className={style.createMatterContainer}>
      <Button
        onClick={convertToMatter}
        variant='outlined'
        color='primary'
        className={`${style.createMatterButton} ${
          isConvertingToMatter ? style.loading : ''
        }`}
        disabled={
          // eslint-disable-next-line @stylistic/js/max-len
          !!connection.convertedToMatterAt || !connection?.permissions?.userDetails
        }
        data-onboarding-id={steps[2].refId}
        data-onboarding-position='right'
      >
        {connection.convertedToMatterAt ? (
          <MatterIcon className={style.tickIcon} />
        ) : isConvertingToMatter ? (
          <div className={style.loadingIconContainer}>
            <LoadingSvg className={style.loadingIcon} />
          </div>
        ) : (
          <PlusIcon className={style.createMatterIcon} />
        )}
        <Typography variant='button' className={style.createText}>
          {connection.convertedToMatterAt
            ? t('lawyer.matter-created')
            : isConvertingToMatter
              ? t('lawyer.creating-matter')
              : t('lawyer.create-matter')}
        </Typography>
      </Button>
      {showIntakeTooltip && 
      <span className={style.tooltip}>{tooltip}</span>}
    </div>
  );
};
